/* ID Uniforms theme — minimal interactivity */
(function () {
  // Mobile nav toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) nav.hidden = !nav.hidden;
    }
  });

  // Hero "Find your school" -> route to /search
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-school-search]');
    if (!form) return;
    // Native GET to /search handles it; nothing extra needed.
  });
})();
